import React, { useState } from "react";
import { useTable, useGlobalFilter } from "react-table";

const ArjunOilPaginated = ({ data, columns, pageIndex, pageCount, totalCount, onPageChange }) => {
    const [searchText, setSearchText] = useState("");

    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow, setGlobalFilter } = useTable(
        {
            columns,
            data,
        },
        useGlobalFilter
    );

    const handleSearch = (e) => {
        const value = e.target.value;
        setSearchText(value);
        setGlobalFilter(value || undefined);
    };

    const canPreviousPage = pageIndex > 1;
    const canNextPage = pageIndex < pageCount;

    return (
        <div className="customTable">
            <div className="customTable__header d-flex justify-content-end mb-3">
                <div className="customTable__right">
                    <div className="customTable__searchFilter">
                        <label>Search:</label>
                        <input
                            className="form-control"
                            maxLength="40"
                            type="text"
                            value={searchText}
                            onChange={handleSearch}
                        />
                    </div>
                </div>
            </div>
            <div className="customTable__body">
                <div className="table-responsive">
                    <table className="table table-striped table-bordered sticky_table" {...getTableProps()}>
                        <thead>
                            {headerGroups.map((headerGroup) => {
                                const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps();
                                return (
                                    <tr key={key} {...headerGroupProps}>
                                        {headerGroup.headers.map((column) => {
                                            const { key, ...headerProps } = column.getHeaderProps();
                                            return <th key={key} {...headerProps}>{column.render("Header")}</th>;
                                        })}
                                    </tr>
                                );
                            })}
                        </thead>
                        {rows?.length ? (
                            <tbody {...getTableBodyProps()}>
                                {rows.map((row) => {
                                    prepareRow(row);
                                    const { key, ...rowProps } = row.getRowProps();
                                    return (
                                        <tr key={key} {...rowProps}>
                                            {row.cells.map((cell) => {
                                                const { key, ...cellProps } = cell.getCellProps();
                                                return <td key={key} {...cellProps}>{cell.render("Cell") ? cell.render("Cell") : "Null"}</td>;
                                            })}
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={12} style={{ textAlign: "center", display: "table-cell", textTransform: "Capitalize" }}>
                                        No data found
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
            </div>
            <div className="customTable__footer">
                <div className="customTable__left">
                    <div className="customTable__totalTransactions">
                        <p>
                            Total Transactions: <span>{totalCount || 0}</span>
                        </p>
                    </div>
                </div>
                <div className="customTable__right">
                    <div className="customTable__top">
                        <div className="customTable__totalPages">
                            <p>
                                Page
                                <select className="form-control selectArrow" value={pageIndex} onChange={(e) => onPageChange(Number(e.target.value))}>
                                    {Array.from({ length: Math.max(pageCount, 1) }, (_, i) => i + 1).map((p) => (
                                        <option key={p} value={p}>
                                            {p}
                                        </option>
                                    ))}
                                </select>
                                of <span>{Math.max(pageCount, 1)}</span>
                            </p>
                        </div>
                    </div>
                    <div className="customTable__bottom">
                        <div className="customTable__buttons">
                            <span className="btn btn-outline-primary" onClick={() => canPreviousPage && onPageChange(pageIndex - 1)} disabled={!canPreviousPage}>
                                {"Previous"}
                            </span>
                            <span className="btn btn-outline-primary" onClick={() => canNextPage && onPageChange(pageIndex + 1)} disabled={!canNextPage}>
                                {"Next"}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ArjunOilPaginated;
